import { Component, OnInit } from '@angular/core';
import {Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';


@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.css']
})
export class AuthenticateComponent implements OnInit {

  constructor(private authService:AuthService) { }

  ngOnInit() {
    console.log('hi');
  }

}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/shared/authenticate/authenticate.component.ts